import { LtlPipelineViewModel } from "../../../../ViewModel/LtlPipelineViewModel";
import { LtlRoutingViewModel } from "../../../../ViewModel/LtlRoutingViewModel";

export function isFinished(
  item: LtlPipelineViewModel,
  routing?: Array<LtlRoutingViewModel>
) {
  const routingLength = item.routing?.length || 0;
  const newRoutingLength = routing?.length || 0;
  // if routings become less then before, then set isFinished to false
  if (newRoutingLength < routingLength) {
    return false;
  }

  if (newRoutingLength > 0 && routing) {
    const lastRouting = routing[newRoutingLength - 1];
    const isPlantRoute = lastRouting.IsPlantRoute;
    if (isPlantRoute) {
      return true;
    }
  }

  return item.IsFinished;
}
